import React from 'react'

import {Grid, GridProps} from '../../grid'
import {makeStyles} from '../../theme'

const useClasses = makeStyles(
  {
    root: {height: '100%'},
  },
  {name: 'SectionContainer'},
)

const SectionContainer: React.FC<React.PropsWithChildren<GridProps>> = props => {
  const classes = useClasses()

  return <Grid classes={classes} direction="column" {...props} wrap="nowrap" container />
}

export default SectionContainer
